import { WorkgroupType } from '.';
import { WorkgroupMember } from '.';

export class WorkgroupListing{

    constructor(
        public id:string,
        public parentWorkgroupId:string,
        public name:string,
        public type:WorkgroupType,
        public members:WorkgroupMember[]
    ){}
}